import { render, staticRenderFns } from "./AnalysesController.vue?vue&type=template&id=749956d6&scoped=true&"
import script from "./AnalysesController.vue?vue&type=script&lang=ts&"
export * from "./AnalysesController.vue?vue&type=script&lang=ts&"
import style0 from "./analyses-controller.scss?vue&type=style&index=0&id=749956d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749956d6",
  null
  
)

export default component.exports